import React from "react";
import { Empty, List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGoodFaiths } from "services/guests.services";

import { FormType } from "utils/enums";
import IntakeFormModal from "containers/IntakeForms/components/IntakeFormModal";
import GoodFaithCard from "./components/GoodFaithCard";
import moment from "moment";

const DEFAULT_PAGE_SIZE = 10;

export default function GoodFaithsList({
  isSmallDevice,
  searchText,
  page,
  setPage,
  sorting,
  date,
  npFilter,
}) {
  const dispatch = useDispatch();
  const abortConRef = React.useRef();

  const wholeStaff = useSelector((state) => state.user?.wholeStaff);
  const allRoles = useSelector((state) => state.roles.allRoles);
  const filteredStaff = React.useMemo(() => {
    return wholeStaff
      ?.filter?.((staff) => {
        const role = allRoles?.find?.((role) => role.roleId === staff?.roleId);
        if (
          role?.permissions?.find?.(
            (permission) => permission.permissionName === "GFE Signature"
          )
        )
          return true;
        return false;
      })
      ?.map((staff) => ({
        value: staff.staffId,
        label: staff.firstName + " " + staff.lastName,
        isActive: staff.isActive,
      }));
  }, [wholeStaff, allRoles]);
  const { currentUser } = useSelector((state) => {
    return {
      currentUser: state.user.currentUser,
    };
  });

  const [forms, setForms] = React.useState({
    data: [],
    isLoading: true,
    totalRecords: 0,
  });
  const [showGoodFaithExam, setshowGoodFaithExam] = React.useState({
    visible: false,
    isEdit: false,
    form: null,
  });


  function transformFilter(filter) {
    const newFilter = { ...filter };

    if (filter?.nursePhysician1Ids) {
      if (!Array.isArray(filter.nursePhysician1Ids)) {
        newFilter.nursePhysician1Ids = [filter.nursePhysician1Ids]
      }
    }
    if (filter?.nursePhysician2Ids) {
      if (!Array.isArray(filter.nursePhysician2Ids)) {
        newFilter.nursePhysician2Ids = [filter.nursePhysician2Ids]
      }
    }
    console.log('newFilter', newFilter)

    return newFilter
  }
  const getData = (page, text = "") => {
    setForms((prev) => ({ ...prev, isLoading: true }));
    if (abortConRef.current) abortConRef.current.abort();
    abortConRef.current = new AbortController();


    dispatch(
      getGoodFaiths(
        {
          skip: ((page.page ?? 1) - 1) * page.pagesize,
          pageSize: page.pagesize,
          includeActive: true,
          searchString: text?.length > 0 ? text : null,
          sortBy: sorting,
          asc: true,
          fromServiceDate: date?.[0]
            ? moment(date[0]).format("YYYY-MM-DD")
            : null,
          toServiceDate: date?.[1]
            ? moment(date[1]).format("YYYY-MM-DD")
            : null,

          formTypeId: FormType.goodFaithExam,
          ...transformFilter(npFilter)
        },
        true,
        abortConRef?.current?.signal
      )
    )
      .then((res) => {
        if (res?.status === "success") {
          setForms((state) => ({
            ...state,
            data: res?.data,
            totalRecords: res?.totalRecords,
          }));
        }
      })
      .finally(() => {
        setForms((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  function renderItem(form, index) {
    const tempForm = form.isExpired ? emptifyForm(form) : form;

    return (
      <GoodFaithCard
        form={tempForm}
        filteredStaff={filteredStaff}
        key={form.customerId} // TODO: Guest > Form
        getData={() => getData(page, searchText)}
        isSmallDevice={isSmallDevice}
        onClick={() => {
          setshowGoodFaithExam({
            form: tempForm,
            visible: true,
            isEdit: !tempForm?.isGoodFaithFormSubmitted,
          });
        }}
        canOpenGFE={currentUser?.permissions?.find?.(
          (permission) => permission.permissionName === "GFE Admin"
        )}
      />
    );
  }

  React.useEffect(() => {
    getData(page, searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchText, sorting, date, npFilter]);

  return (
    <div
      style={{
        overflowY: "auto",
        background: "#e5e8ee",
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        paddingBottom: 30,
      }}
    >
      <List
        itemLayout="vertical"
        size="large"
        pagination={{
          onChange: (page, pagesize) => {
            setPage({
              page: page,
              pagesize: pagesize,
            });
          },
          pageSize: page.pagesize,
          total: forms?.totalRecords ?? 0,
          showSizeChanger: true,
          pageSizeOptions: [10, 25, 50, 100, 250],
          current: page.page,

        }}
        dataSource={forms?.data ?? []}
        // loading={guests?.isLoading}
        renderItem={renderItem}
        locale={{ emptyText: <Empty description="No GFEs" /> }}
      />
      {showGoodFaithExam.visible && (
        <IntakeFormModal
          visible={showGoodFaithExam.visible}
          isEdit={showGoodFaithExam.isEdit} 
          isExpired={showGoodFaithExam?.form?.isExpired}
          title="Good Faith Exam"
          type={FormType.goodFaithExam}
          onSubmit={() => {
            setshowGoodFaithExam({
              form: null,
              visible: false,
              isEdit: false,
            });
            getData(page, searchText);
          }}
          onClose={() =>
            setshowGoodFaithExam({
              form: null,
              visible: false,
              isEdit: false,
            })
          }
          refreshData={() => getData(page, searchText)}
          isSubmitted={showGoodFaithExam?.form?.isGoodFaithFormSubmitted} // TODO: Guest > Form
          formId={showGoodFaithExam?.form?.formValueId}
          customerId={showGoodFaithExam?.form?.customerId} // TODO Guest > Form
          formCode={4}
          formValueId={showGoodFaithExam?.form?.formValueId}
          // orderId={orderId}
          className={`goodfaithexam-${showGoodFaithExam?.form?.customerId}`}
        />
      )}
    </div>
  );
}


const emptifyForm = (form) => {
  return {
    ...form,
    "formValueId": 0,
    "formId": 0,
    "formVersionId": 0,
    "formType": 0,
    "valueJSON": null,
    "designJSON": null,
    "isActive": true,
    "isDesignOutdated": false,
    "hasPhysician1SignedOff": false,
    "hasPhysician2SignedOff": false,
    "isGoodFaithFormSubmitted": false,
    "isExpired": true,
    "firstPhysicianStaffId": null,
    "requiredSecondSignature": false,
    "canFillGoodFaithForm": true,
    "secondPhysicianStaffId": null,
    "isReopened": false,
    "firstPhysicianSignOffDate": null,
    "secondPhysicianSignOffDate": null,
    "formStatus": 0
  }

}